import { getSintegradaServerApi } from "@/services/api";
import { ResumeGrouped } from "@/services/esus/attendanceService";

export type ReceptionDashboardParams = {
	uf: string;
	ibgeCode: string;
	startDate: string;
	endDate: string;
	cnes?: string;
	minAge?: number;
	maxAge?: number;
	professionalId?: number;
	professionalCns?: string;
	professionalName?: string;
};

export type ReceptionDashboardData = {
	aggregatedByHealthUnit: ResumeGrouped<string, null>[];
	aggregatedByPeriod: ResumeGrouped<string, null>[];
	aggregatedByDayOfWeek: ResumeGrouped<string, null>[];
	aggregatedByGender: ResumeGrouped<string, null>[];
	aggregatedByCity: ResumeGrouped<string, null>[];
	aggregatedByNeighborhood: ResumeGrouped<string, null>[];
	evasions: number;
	totalAttendances: number;
	averageAttendancesPerDay: number;
	obitos: number;
	obitos_ate_24h: number;
	obitos_maior_24h: number;
	maxDay: number;
	minDay: number;
	por_turno: Array<{ total: number; turno: string }>;
};

export async function getReceptionDashboard({ ...params }: ReceptionDashboardParams) {
	const url = `/attendance/reception-dashboard`;

	const { data } = await getSintegradaServerApi().get<ReceptionDashboardData>(url, params);

	// Garantir que todas as propriedades sejam arrays válidos
	const defaultData: ReceptionDashboardData = {
		aggregatedByHealthUnit: [],
		aggregatedByPeriod: [],
		aggregatedByDayOfWeek: [],
		aggregatedByGender: [],
		aggregatedByCity: [],
		aggregatedByNeighborhood: [],
		evasions: 0,
		totalAttendances: 0,
		averageAttendancesPerDay: 0,
		obitos: 0,
		obitos_ate_24h: 0,
		obitos_maior_24h: 0,
		maxDay: 0,
		minDay: 0,
		por_turno: [],
	};

	if (!data) {
		return defaultData;
	}

	// Validar e garantir que todas as propriedades de array sejam arrays válidos
	return {
		aggregatedByHealthUnit: Array.isArray(data.aggregatedByHealthUnit)
			? data.aggregatedByHealthUnit
			: [],
		aggregatedByPeriod: Array.isArray(data.aggregatedByPeriod) ? data.aggregatedByPeriod : [],
		aggregatedByDayOfWeek: Array.isArray(data.aggregatedByDayOfWeek)
			? data.aggregatedByDayOfWeek
			: [],
		aggregatedByGender: Array.isArray(data.aggregatedByGender) ? data.aggregatedByGender : [],
		aggregatedByCity: Array.isArray(data.aggregatedByCity) ? data.aggregatedByCity : [],
		aggregatedByNeighborhood: Array.isArray(data.aggregatedByNeighborhood)
			? data.aggregatedByNeighborhood
			: [],
		evasions: data.evasions ?? 0,
		totalAttendances: data.totalAttendances ?? 0,
		averageAttendancesPerDay: data.averageAttendancesPerDay ?? 0,
		obitos: data.obitos ?? 0,
		obitos_ate_24h: data.obitos_ate_24h ?? 0,
		obitos_maior_24h: data.obitos_maior_24h ?? 0,
		maxDay: data.maxDay ?? 0,
		minDay: data.minDay ?? 0,
		por_turno: Array.isArray(data.por_turno) ? data.por_turno : [],
	} as ReceptionDashboardData;
}
